import CopyWithTooltip from 'components/CopyWithTooltip';
import DialogActions from '@material-ui/core/DialogActions';
import React from 'react';
import { Button, Dialog } from '@attain-sre/attain-design-system';
import { CANCEL, COPY_OAUTH_URL, OAUTH_URL } from '../../../content';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import * as Styled from '../createOAuthUrlModal/index.styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(3),
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 23,
      paddingLeft: 16,
      paddingTop: 16,
    },
    bodyContainer: {
      padding: 0,
    },
    oauthUrlContainer: {
      padding: theme.spacing(2),
      backgroundColor: '#f5f5f5',
      borderRadius: 4,
      wordBreak: 'break-all',
    },
    oauthUrlText: {
      fontSize: 14,
      fontFamily: 'monospace',
    },
    label: {
      fontSize: 16,
      fontWeight: 500,
      marginBottom: 8,
      fontFamily: 'Calibre-Regular, sans-serif',
    },
  })
);

interface OAuthUrlViewModalProps {
  open: boolean;
  onClose: () => void;
  oauthUrl: string;
}

const OAuthUrlViewModal = ({
  open,
  onClose,
  oauthUrl,
}: OAuthUrlViewModalProps) => {
  const classes = useStyles();

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      className={classes.root}
      onClose={onClose}
      open={open}
      headerID="viewOAuthUrlHeader"
      header={
        <Styled.CardHeader>
          <Styled.CardTitle>{OAUTH_URL}</Styled.CardTitle>
        </Styled.CardHeader>
      }
      bodyID="viewOAuthUrlBody"
      body={
        <div className={classes.bodyContainer}>
          <div className={classes.oauthUrlContainer}>
            <div className={classes.oauthUrlText}>{oauthUrl}</div>
          </div>
        </div>
      }
      footer={
        <DialogActions>
          <CopyWithTooltip value={oauthUrl}>
            <Button color="primary" variant="contained">
              {COPY_OAUTH_URL}
            </Button>
          </CopyWithTooltip>
          <Button color="primary" onClick={onClose} variant="outlined">
            {CANCEL}
          </Button>
        </DialogActions>
      }
    />
  );
};

export default OAuthUrlViewModal;
